import type { FunctionReturnType } from "convex/server";
import type { api } from "@convex/_generated/api";

export type OpenCheckout = FunctionReturnType<
  typeof api.cart.checkoutAttemptQueries.getActiveCheckoutAttempt
>;

export function isSilentlyReleasable(
  attempt: OpenCheckout | undefined,
): attempt is NonNullable<OpenCheckout> {
  return (
    attempt != null &&
    attempt.combinedPayment === true &&
    !attempt.paymentNeedsReview &&
    attempt.paidUnitCount === 0
  );
}
